module.exports = __webpack_public_path__ + "static/media/marisa5.57f32a03.mp3";